import React from "react";
//Limitless imports
import { getAllDirtyFields } from "../../utils/FieldValidators";
import { validateAddressForm } from "../../utils/validators/AddressFormValidator";
const getInitialState = profile => {
  const state = {
    address1: {
      value: profile.address1 || "",
      pristine: true
    },
    address2: {
      value: profile.address2 || "",
      pristine: true
    },
    town: {
      value: profile.town || "",
      pristine: true
    },
    postalCode: {
      value: profile.postalCode || "",
      pristine: true
    }
  };
  return state;
};
export const useExpertProfileAddress = (profile = {}) => {
  const initialAddressState = getInitialState(profile);
  const [address, setAddress] = React.useState(initialAddressState);
  React.useEffect(() => {
    if (profile.loading === false) {
      setAddress(getInitialState(profile));
    }
  }, [profile]);
  const handleValueChange = (key, value) => {
    const newAddess = {
      ...address
    };
    newAddess[key] = {
      value,
      pristine: false
    };
    setAddress(newAddess);
  };
  const getAddressPayload = () => {
    return getAllDirtyFields(address);
  };

  //extraData = mobile number
  const validateAddress = (isMandatory, extraData) => {
    return validateAddressForm({
      ...address,
      ...extraData
    }, isMandatory);
  };
  return {
    handleValueChange,
    address,
    getAddressPayload,
    validateAddress
  };
};